export default "__VITE_ASSET__fT3$rMXd__"